import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { RecommendedUniversity } from '@uc/web/shared/data-models';
import { Observable } from 'rxjs';
import { RecommendedUnisSwiperComponent } from './recommended-unis-swiper/recommended-unis-swiper.component';
import { RecommendedUniSingleComponent } from '../components/recommended-uni-single/recommended-uni-single.component';
import { Product, ProductEnum } from '@uc/shared/data-models';
import { fetchRecommendedUniversities } from '../+state/recommended-universities.actions';
import {
	getStateRecommendedUniversitiesPostgraduate,
	getStateRecommendedUniversitiesUndergraduate,
} from '../+state/recommended-universities.selectors';

@Component({
	selector: 'uc-recommended-unis-carousel',
	templateUrl: './recommended-unis-carousel.component.html',
	imports: [AsyncPipe, RecommendedUnisSwiperComponent, RecommendedUniSingleComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecommendedUnisCarouselComponent implements OnInit {
	recommendedUniversities$!: Observable<RecommendedUniversity[] | undefined>;
	product!: Product;
	componentName = '';

	constructor(
		private _store: Store,
		private _router: Router,
	) {}

	ngOnInit(): void {
		const url = this._router.url;
		this.product = url.includes('/postgraduate')
			? ProductEnum.Postgraduate
			: ProductEnum.Undergraduate;
		this.componentName =
			this.product === ProductEnum.Undergraduate
				? 'UG Recommended Universities'
				: 'PG Recommended Universities';

		this._store.dispatch(fetchRecommendedUniversities());

		if (this.product === 'postgraduate') {
			this.recommendedUniversities$ = this._store.select(
				getStateRecommendedUniversitiesPostgraduate,
			);
			return;
		}
		this.recommendedUniversities$ = this._store.select(
			getStateRecommendedUniversitiesUndergraduate,
		);
	}
}
